module.exports = __webpack_public_path__ + "img/pwc.228ec00.svg";